import React, {useEffect} from 'react'
import video from '../assets/trailer_02.mp4'
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
    useEffect(() => {
        AOS.init();
      }, [])
  return (
    <section className="about scoll flex min-h-[700px] sm:min-h-[900px] xl:min-h-[1000px]" id="about">
        <div className="custom-shape-divider-top-1677606819">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M649.97 0L550.03 0 599.91 54.12 649.97 0z" className="shape-fill" style={{fill: '#0D1630'}}></path>
            </svg>
        </div>
        <div className="about-section-sticker sm:none"></div>
        <div className="about-section items-center px-10">
                <div className=""></div>
                <div className="about-text">
                    <h1 data-aos="fade-right" className="font-face-tk about-title text-left sm:text-left lg:text-right text-xl sm:text-xl md:text-3xl lg:text-3xl" style={{textTransform: 'uppercase', marginBottom: '50px', fontWeight: 'bold', color: '#F68C1F'}}>
                    Defend yourself against the horde</h1>
                    <p data-aos="fade-right" className="about-paragraph flex flex-wrap text-left lg:text-right text-sm md:text-lg lg:text-xl lg:w-[90%] lg:ml-auto" style={{color: 'ffff00', marginBottom: '50px' }}> 
                    A top down free roaming shooter where you play as a burger delivery man who is
                    completing his orders during the zombie apocalypse. Pick up and deliver orders
                    while shooting and driving against an ever growing horde of zombies.
                    </p>
{ /*<iframe width="600"
      height="350" src={video} 
      allow=" autoplay; playsinline; loop;  picture-in-picture"
      allowFullScreen>
            
  </iframe>*/}
  
                    <video data-aos="zoom-in" controls autoPlay muted playsInline width="100%" tabIndex={-1}>
                    <source src={video} type="video/mp4"/>
                    </video>
                </div>
        </div>
    </section>
  )
}

export default About